export default class SearchFormController {
  constructor($state) {
    'ngInject';

    this.$state = $state;
  }

  $onInit() {
    this.searchParams = {};
  }

  handleSearchSubmit(keywords) {
    const isSearchState = this.$state.$current.name === 'engineer.search';

    this.$state.$current.name = 'engineer.search'
    if (isSearchState || keywords) {
      return this.$state.go('engineer.search', {keywords});
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/screens/engineer/components/search-form/search-form.controller.js